import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/deleteAlert';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const { goalId, alertId } = action?.payload || {};
  try {
    yield call(
      axios.delete,
      `${config.API_URL}/goals/${goalId}/alerts/${alertId}`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess({ alertId, at: Date.now() }));
  } catch (error) {
    // The panel removes the row optimistically and reloads the list to
    // revert on failure — keep the error local, matching the previous
    // inline behavior.
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  // takeEvery: deleting several rules in quick succession must all land.
  yield takeEvery(REQUEST, operation);
}
